import { useEffect, useState } from "react";

import { SubscriptionTier } from "@repo/ui/pricing-hooks";
import { useRemoteConfig } from "@shapr3d/frontend-lib";

import { CancellationSurveyModal } from "../CancellationSurveyModal/CancellationSurveyModal";
import { SubscriptionCancelModal } from "../SubscriptionCancelModal/SubscriptionCancelModal";

export const CancellationFlow: React.FC<{
  open: boolean;
  onClose: () => void;
  onCancelSubscription: () => void;
  isLoading: boolean;
  editorSeatCount: number;
  isSubscriptionInGracePeriod: boolean;
  subscriptionExpirationDate: string;
  subscriptionTier: SubscriptionTier;
}> = ({
  open,
  onClose,
  onCancelSubscription,
  isLoading,
  editorSeatCount,
  isSubscriptionInGracePeriod,
  subscriptionExpirationDate,
  subscriptionTier,
}) => {
  const cancellationSurveyFlag = useRemoteConfig("web_cancellation_survey-cd");
  const isFlagLoading = cancellationSurveyFlag === undefined;
  const isTreatment = cancellationSurveyFlag === "treatment";

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isSurveyOpen, setIsSurveyOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setIsConfirmOpen(true);
      setIsSurveyOpen(false);
    } else {
      setIsConfirmOpen(false);
      setIsSurveyOpen(false);
    }
  }, [open]);

  return (
    <>
      <SubscriptionCancelModal
        open={isConfirmOpen}
        onClose={() => {
          setIsConfirmOpen(false);
          // Only notify parent if we're not transitioning to the survey
          if (!isSurveyOpen) onClose();
        }}
        isLoading={isLoading || isFlagLoading}
        editorSeatCount={editorSeatCount}
        isSubscriptionInGracePeriod={isSubscriptionInGracePeriod}
        subscriptionExpirationDate={subscriptionExpirationDate}
        subscriptionTier={subscriptionTier}
        mode={isTreatment ? "survey" : "cancel"}
        onCTA={
          isTreatment
            ? () => {
                setIsConfirmOpen(false);
                setIsSurveyOpen(true);
              }
            : onCancelSubscription
        }
      />
      <CancellationSurveyModal
        open={isSurveyOpen}
        onClose={() => {
          setIsSurveyOpen(false);
          onClose();
        }}
        onCancelSubscription={onCancelSubscription}
        isLoading={isLoading}
        subscriptionTier={subscriptionTier}
        subscriptionExpirationDate={subscriptionExpirationDate}
      />
    </>
  );
};
